export class FieldValidationMessage {
    validationName: string;
    message: string;
    messageParams: Record<string, string | number>;

    constructor(validationName: string, message: string, messageParams: Record<string, string | number> = {}) {
        this.validationName = validationName;
        this.message = message;
        this.messageParams = messageParams;
    }
}
